import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './route';
import { Login } from '../pages/Login';
import { RecuperarSenha } from '../pages/RecuperarSenha';
import { ListagemCadastros } from '../pages/Usuario/Listagem';
import { CredencialPerfil } from '../pages/Usuario/Perfil/Credencial';
import { PerfilForm } from '../pages/Usuario/Perfil/Editar';
import { ErrosWebhook } from '../pages/ErrosWebhook';
import { ParamtrosGerenciamentoRisco } from '../pages/Gerenciamento-risco/Parametros';
import { CadastroStatus } from '../pages/Gerenciamento-risco/Cadastro';
import Relatorios from '../pages/Relatorios';
import { Migracao } from '../pages/Migracao';
import { PainelDeControle } from '../pages/PainelDeControle';
import { PainelControleExterno } from '../pages/PainelExterno';
import { AtendimentoExterno } from '../pages/AtendimentoExterno';
import { Atendimento } from '../pages/Atendimento';
import { AtendimentoFinalizado } from '../pages/AtendimentoFinalizado';
import { Historico } from '../pages/Historico';
import PortalInformacoes from '../pages/PortalInformacoes';
import { LogsIntegracao } from '../pages/LogsIntegracao';
import { LogsCadastros } from '../pages/LogsCadastros';
import {
  UsuariosV2,
  ClientesV2,
  GruposUsuarioV2,
  ConsultasV2,
  MatrizesV2,
} from '../pages/CadastrosV2';

function Routes() {
  return (
    <Switch>
      <Route exact path="/recuperar-senha/:token" component={RecuperarSenha} />
      <Route exact path="/" component={Login} />
      <Route
        exact
        path="/cadastro"
        component={ListagemCadastros}
        titleHeader=""
        isPrivate
        roles={[
          'CadastroGrupoUsuario',
          'CadastroConsulta',
          'CadastroCliente',
          'CadastroUsuario',
          'CadastroMatriz',
        ]}
      />
      <Route
        exact
        path="/cadastros-v2/usuarios"
        component={UsuariosV2}
        titleHeader="Cadastros v2"
        isPrivate
        roles={['CadastroUsuario']}
      />
      <Route
        exact
        path="/cadastros-v2/clientes"
        component={ClientesV2}
        titleHeader="Cadastros v2"
        isPrivate
        roles={['CadastroCliente']}
      />
      <Route
        exact
        path="/cadastros-v2/grupos-de-usuario"
        component={GruposUsuarioV2}
        titleHeader="Cadastros v2"
        isPrivate
        roles={['CadastroGrupoUsuario']}
      />
      <Route
        exact
        path="/cadastros-v2/consultas"
        component={ConsultasV2}
        titleHeader="Cadastros v2"
        isPrivate
        roles={['CadastroConsulta']}
      />
      <Route
        exact
        path="/cadastros-v2/matrizes"
        component={MatrizesV2}
        titleHeader="Cadastros v2"
        isPrivate
        roles={['CadastroMatriz']}
      />
      <Route
        exact
        path="/perfil/editar"
        component={PerfilForm}
        titleHeader=""
        isPrivate
      />
      <Route
        exact
        path="/perfil/credenciais"
        component={CredencialPerfil}
        titleHeader="Credenciais"
        isPrivate
      />
      <Route
        exact
        path="/gestao/erros-webhook"
        component={ErrosWebhook}
        titleHeader="Erros de Webhook"
        isPrivate
        roles={['ControleWebhook']}
      />
      <Route
        exact
        path="/relatorios"
        component={Relatorios}
        titleHeader=""
        isPrivate
        roles={['MenuRelatorio']}
      />
      <Route
        exact
        path="/parametros-gr"
        component={ParamtrosGerenciamentoRisco}
        titleHeader=""
        isPrivate
        roles={['ControleParametrosGerais']}
      />
      <Route
        exact
        path="/cadastro-de-status"
        component={CadastroStatus}
        titleHeader="Cadastro de Status"
        isPrivate
        roles={['MenuRelatorio']}
      />
      <Route
        exact
        path="/painel-de-controle"
        component={PainelDeControle}
        titleHeader="Painel de controle"
        isPrivate
        roles={['MenuPainelControle', 'Operador', 'EditarCadastroPainel']}
      />
      <Route
        exact
        path="/atendimento-finalizado"
        component={AtendimentoFinalizado}
        titleHeader={null}
        watch
        isPrivate
      />
      <Route
        exact
        path="/consultas-externas-painel"
        component={PainelControleExterno}
        titleHeader="Painel de Controle"
        isPrivate
        roles={['MenuConsultasExternas', 'OperadorExterno']}
      />
      <Route
        exact
        path="/atendimento-externo"
        component={AtendimentoExterno}
        titleHeader="Painel de Controle"
        isPrivate
        roles={['MenuAtendimentoExterno', 'OperadorExterno']}
      />
      <Route
        exact
        path="/atendimento"
        component={Atendimento}
        titleHeader={null}
        isPrivate
      />
      <Route
        exact
        path="/migracao"
        component={Migracao}
        titleHeader=""
        isPrivate
        roles={['ControleMigracao']}
      />
      <Route
        exact
        path="/portal-de-informacoes"
        component={PortalInformacoes}
        titleHeader="Portal de informações"
        isPrivate
        roles={['PortalInformacoes']}
      />
      <Route
        exact
        path="/historico"
        component={Historico}
        titleHeader=""
        isPrivate
        roles={['HistoricoAtendimento']}
      />
      <Route
        exact
        path="/gestao/logs-integracao"
        component={LogsIntegracao}
        titleHeader="Logs de integração"
        isPrivate
        roles={['VisualizarLogsIntegracao']}
      />
      <Route
        exact
        path="/gestao/logs-cadastros"
        component={LogsCadastros}
        titleHeader="Logs de cadastros"
        isPrivate
        roles={['VisualizarLogsCadastros']}
      />
    </Switch>
  );
}

export default Routes;
